export const SET_DATA = "SET_DATA";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_PAGE_BREAK = "SET_PAGE_BREAK";
export const QUESTION_FETCHING_INIT = "QUESTION_FETCHING_INIT";
export const QUESTION_FETCHING_COMPLETE = "QUESTION_FETCHING_COMPLETE";
